import React, {Component} from "react";
import {connect} from "react-redux";
import Autosuggest from 'react-autosuggest';
import {escapeRegexCharacters, normalizeString} from "./../../helpers/formatters";
import {setSelectMapControlAction} from "./../../actions/SettingsAction";
import SVGIcon from "./../svg/SVGIcon";

import "./Select.css";

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.name;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div>{suggestion.name}</div>
);

class Select extends Component {
  constructor(props) {
    super();
    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      value: '',
      suggestions: [],
      showSelect: false
    };
    this.getSuggestions = this.getSuggestions.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
  }

  // Teach Autosuggest how to calculate suggestions for any given input value.
  getSuggestions = value => {
    const {searchList, optionsKey} = this.props;
    const escapedValue = escapeRegexCharacters(normalizeString(value.trim()));
    const items = searchList.find(cat => cat.title === optionsKey).items;
    if (escapedValue === '' ) {
      return items;
    }
    return items.filter(item => item.meta.search(escapedValue) !== -1);
  };

  onChange = (event, {newValue}) => {
    this.setState({
      value: newValue
    });
  };

  onBlur = (event, {highlightedSuggestion}) => {
    const {optionsKey, setSelectMapControlAction, selectedItems} = this.props;
    const selectedItem = selectedItems[optionsKey];

    if (highlightedSuggestion){
      setSelectMapControlAction(highlightedSuggestion, optionsKey);
    } else if (selectedItem) {
      setSelectMapControlAction(selectedItem, optionsKey);
    }
    this.setState({
      value: '',
      showSelect:false,
      suggestions: []
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({value, reason}) => {
    let showSelect = this.state.showSelect
    if (reason ==='suggestion-selected'){
      showSelect = false;
    }
    this.setState({
      showSelect: showSelect,
      suggestions: this.getSuggestions(value)
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  onSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
    const {optionsKey} = this.props;
    this.props.setSelectMapControlAction(suggestion, optionsKey);
    this.setState({
      value: '',
      suggestions: []
    });
  }

  clearOnClick = () =>{
    //const {optionsKey} = this.props;
    //this.props.setSelectMapControlAction(false, optionsKey);
    this.setState({
      showSelect: !this.state.showSelect,
      suggestions: this.getSuggestions('')
    });
  }

  render() {
    const {value, suggestions, showSelect} = this.state;
    const {selectedItems, optionsKey} = this.props;

    const selectedItem = selectedItems[optionsKey];

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: `Search ${optionsKey}`,
      value,
      onChange: this.onChange,
      onBlur: this.onBlur,
      onKeyPress:(e) => {e.key === 'Enter' && e.preventDefault();}
    };

    // Finally, render it!
    return (
      <div className="fow-select">
        {selectedItem &&
          <div className="fow-select-selected-block" onClick={this.clearOnClick}>
          <span>{selectedItem.name}</span><SVGIcon name="arrow-down" stroke="#000" width={30} />
          </div>
        }
        <div className={`fow-select-container ${showSelect ? 'fow-select-show' : 'fow-select-hide'} `}>
          <Autosuggest
            id={`fow-select-${optionsKey}`}
            alwaysRenderSuggestions={true}
            suggestions={suggestions}
            focusInputOnSuggestionClick={false}
            highlightFirstSuggestion={true}
            onSuggestionSelected={this.onSuggestionSelected}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            inputProps={inputProps}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    searchList: state.db.search.options,
    selectedItems: state.settings.map
  };
};
const mapDispatchToProps = dispatch => ({
  setSelectMapControlAction: (data,group) => dispatch(setSelectMapControlAction(data,group)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Select);
